import React from 'react'
import PropTypes from 'prop-types';

Cita.propTypes = {
    cita : PropTypes.object.isRequired,
    eliminarCita : PropTypes.func.isRequired
}

export default function Cita({cita, eliminarCita}) {
    return (
        <div className="card m-2 shadow">
            <h4 className="card-header">
                <span
                    onClick={() => eliminarCita(cita.id)}
                    className="borrar pb-2 mr-1 text-danger">&times;</span>  
                 {cita.cliente}
            </h4>
            <div className="card-body">
                <p className="font-weight-bold">{cita.contacto}</p>
                <p className="text-justify">{cita.mensaje}</p>
                <small>{cita.fecha}</small>
            </div>
        </div>
    )
}
